import { useViewStore } from '../../stores/viewStore'

export default function Toggle3D2D() {
  const is2DMode = useViewStore((s) => s.is2DMode)
  const toggle2DMode = useViewStore((s) => s.toggle2DMode)

  return (
    <button
      className={`toggle-3d2d${is2DMode ? ' toggle-3d2d--active' : ''}`}
      onClick={toggle2DMode}
    >
      {is2DMode ? '2D' : '3D'}
    </button>
  )
}
